<template>
  <div class="header-main"
    :class="accountStatus ? accountStatus.statuses[accountStatus.status] : ''"
  >
    <p class="breadcrumb-text">{{ breadcrumb }}</p>
    <div class="account-status strong-text text-center"
         :class="{'cursor-pointer': accountStatus && accountStatus.status === 1}"
         v-html="accountStatus ? accountStatusTexts[accountStatus.status] : ''"
         @click="accountStatus && accountStatus.status === 1 ? doVerificationProgress() : null">
    </div>
    <div class="header-content">
      <div class="header-icon">
        <img v-if="isMapEnabled" @click="onBellClick" src="../../assets/images/map.svg" alt="map-icon" />
        <img v-if="accountStatus && accountStatus.status === 4" src="../../assets/images/notify-white.svg" alt="notify-icon" />
        <img v-else src="../../assets/images/notify.svg" alt="notify-icon" />
      </div>
      <div class="header-profile">
        <div class="info-logout">
          <p v-if="userAuth !== null" v-text="userAuth.first_name + ' ' + userAuth.last_name" class="info-user"></p>
          <span @click="logout" class="logout-button">Logout</span>
        </div>
      </div>
    </div>
    <ModalVerifyProgress
      v-if="isShowModalVerifyProgress"
      @close="isShowModalVerifyProgress = false"
    />
  </div>
</template>

<script>
import DibbleJS from "@/dibble";
import DibbleTranslation from "@/translation/translation";
import { ENABLE_MAP_EVENT, EventBus } from "../../utils/event-bus";
import DibbleAPI from "@/api";
import ModalVerifyProgress from "@/components/Dashboard/sub-components/ModalVerifyProgress.vue";
export default {
  name: "NewHeader",
  components: {ModalVerifyProgress},
  data() {
    return {
      translate: DibbleTranslation,
      userAuth: null,
      isMapEnabled: false,
      breadcrumb: '',
      accountStatusTexts: {
        1: 'Your account is not verified<br/> Click here to start the verification process.',
        2: 'Your account is pending approval by the system.',
        4: 'Your account was <strong style="color: #CF132A">Rejected</strong><br/>Click here to contact us for more information.'
      },
      accountStatus: null,
      isShowModalVerifyProgress: false,
    };
  },
  created() {
    this.userAuth = this.$cookies.get("_user");
    EventBus.$on(ENABLE_MAP_EVENT, () => {
      this.isMapEnabled = true;
    });

    if (this.userAuth.is_owner) {
        this.getMyAccountStatus()
        EventBus.$on('reloadAuthStatus', this.getMyAccountStatus)
    }
  },
  methods: {
    doVerificationProgress() {
      this.isShowModalVerifyProgress = true
    },
    getMyAccountStatus() {
        const params = {
            '#request': DibbleAPI.api.getMyAccountStatus
        }
        DibbleJS.callApiRequest(params, (responseData) => {
            DibbleJS.hideLoader()
            if (DibbleAPI.isResponseSuccess(responseData)) {
                this.accountStatus = responseData
                EventBus.$emit('sidebarBgClass', this.accountStatus.statuses[responseData.status])
            } else {
                DibbleJS.toastErrorMessage(responseData.message)
            }
        })
    },
    logout() {
      DibbleJS.confirmBox(this.translate.trans('global.label.logout_confirm'), this.performSystemLogout)
    },
    performSystemLogout() {
      DibbleJS.cookieDestroy();
      this.$router.push('/login');
    },
    onBellClick() {
      if (this.isMapEnabled) {
        this.$router.push("/rental/map")
      }
    }
  },
  watch: {
    ['$route.meta.breadcrumb']: {
      immediate: true,
      handler() {
        if (this.$route.meta.breadcrumb) {
          this.breadcrumb = this.$route.meta.breadcrumb
          if (this.$route.params.id) {
            this.breadcrumb = this.breadcrumb.replace('_id', this.$route.params.id)
          }
        } else {
          this.breadcrumb = ''
        }
      }
    },
    ['$route.name']: {
      immediate: true,
      handler() {
          this.userAuth = this.$cookies.get("_user");
          if (this.userAuth.need_change_password) {
              if (this.$route.name !== 'Account') {
                  return window.location.href = '/account'
              }
          }
      }
    }
  }

};
</script>
<style lang="scss" scoped>
.header-main {
  height: 86px;
  width: 100%;
  background: #e8eff1;
  border-radius: 0px 0px 50px 0px;
  box-shadow: 0px 10px 30px -6px #b6b6b6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 30px;

  &.Unverified {
    background: #ffc3c3;
  }
  &.Pending {
    background: #ffebc2;
  }
  &.Rejected {
    background: #171A1C;
    color: #ffffff;
  }
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.header-icon {
  margin-right: 10px;
  user-select: none;

  img {
    cursor: pointer;
    width: 30px;

    &:nth-child(2) {
      margin-left: 20px;
    }
  }
}

.header-profile {
  display: flex;
  align-items: center;
  user-select: none;
}

.avatar-profile {
  width: 60px;
  height: 60px;
  background: #ccc;
  border-radius: 100%;
}

.info-logout {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}

.info-user {
  color: #555e67;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}
.header-main.Rejected {
    .info-user {
        color: #ffffff;
    }
}

.logout-button {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #2c94ab;
  cursor: pointer;
}

@media only screen and (max-width: 1160px) {
  .header-main {
    height: 60px;
  }

  .header-icon {
    margin-right: 30px;

    img {
      width: 25px;

      &:nth-child(2) {
        margin-left: 10px;
      }
    }
  }

  .avatar-profile {
    width: 40px;
    height: 40px;
    background: #ccc;
    border-radius: 100%;
  }
}

.breadcrumb-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #1975a9;
  padding-left: 20px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
